import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

export class VibeversePortalManager {
    constructor(scene, player, renderLoop) {
        this.scene = scene;
        this.player = player;
        this.renderLoop = renderLoop;

        // Portals
        this.startPortalBox = null;
        this.exitPortalBox = null;
        this.exitPortalInnerMaterial = null;
        this.redirectUrl = null;
        this.createPauseModal();
    }

    async init() {
        try {
            // <create start portal>
            const startPortalGroup = new THREE.Group();
            startPortalGroup.position.set(150, 3.5, 80);
            startPortalGroup.rotation.set(0, -1, 0);
            startPortalGroup.scale.set(0.25, 0.25, 0.25);

            const startPortalGeometry = new THREE.TorusGeometry(15, 2, 16, 100);
            const startPortalMaterial = new THREE.MeshPhongMaterial({
                color: 0xff0000,
                emissive: 0xff0000,
                transparent: true,
                opacity: 0.8,
            });
            const startPortal = new THREE.Mesh(
                startPortalGeometry,
                startPortalMaterial
            );
            startPortalGroup.add(startPortal);

            const startPortalInnerGeometry = new THREE.CircleGeometry(13, 32);
            const startPortalInnerMaterial = new THREE.MeshBasicMaterial({
                color: 0xff0000,
                transparent: true,
                opacity: 0.5,
                side: THREE.DoubleSide,
            });
            const startPortalInner = new THREE.Mesh(
                startPortalInnerGeometry,
                startPortalInnerMaterial
            );
            startPortalGroup.add(startPortalInner);

            const startPortalParticleCount = 500;
            const startPortalParticles = new THREE.BufferGeometry();
            const startPortalPositions = new Float32Array(
                startPortalParticleCount * 3
            );
            const startPortalColors = new Float32Array(
                startPortalParticleCount * 3
            );

            for (let i = 0; i < startPortalParticleCount * 3; i += 3) {
                const angle = Math.random() * Math.PI * 2;
                const radius = 15 + (Math.random() - 0.5) * 4;
                startPortalPositions[i] = Math.cos(angle) * radius;
                startPortalPositions[i + 1] = Math.sin(angle) * radius;
                startPortalPositions[i + 2] = (Math.random() - 0.5) * 4;
                startPortalColors[i] = 0.8 + Math.random() * 0.2;
                startPortalColors[i + 1] = 0;
                startPortalColors[i + 2] = 0;
            }

            startPortalParticles.setAttribute(
                "position",
                new THREE.BufferAttribute(startPortalPositions, 3)
            );
            startPortalParticles.setAttribute(
                "color",
                new THREE.BufferAttribute(startPortalColors, 3)
            );

            const startPortalParticleMaterial = new THREE.PointsMaterial({
                size: 0.1,
                vertexColors: true,
                transparent: true,
                opacity: 0.6,
            });

            const startPortalParticleSystem = new THREE.Points(
                startPortalParticles,
                startPortalParticleMaterial
            );
            startPortalGroup.add(startPortalParticleSystem);

            this.scene.add(startPortalGroup);
            // this.startPortalBox = new THREE.Box3().setFromObject(startPortalGroup);
            this.startPortalBox = startPortalGroup;

            console.log(this.startPortalBox, "group start box");

            this.startPortalParticles = startPortalParticles; // Store for animation
            // </create start portal>

            // <create exit portal>
            const exitPortalGroup = new THREE.Group();
            // exitPortalGroup.position.set(12.5, 3.5, -4.5);
            exitPortalGroup.position.set(-150, 3.5, -80);
            exitPortalGroup.rotation.set(0, -1, 0);
            exitPortalGroup.scale.set(0.25, 0.25, 0.25);

            const exitPortalGeometry = new THREE.TorusGeometry(15, 2, 16, 100);
            const exitPortalMaterial = new THREE.MeshPhongMaterial({
                color: 0x00ff00,
                emissive: 0x00ff00,
                transparent: true,
                opacity: 0.8,
            });
            const exitPortal = new THREE.Mesh(
                exitPortalGeometry,
                exitPortalMaterial
            );
            exitPortalGroup.add(exitPortal);

            const exitPortalInnerGeometry = new THREE.CircleGeometry(13, 32);
            this.exitPortalInnerMaterial = new THREE.MeshBasicMaterial({
                color: 0x00ff00,
                transparent: true,
                opacity: 0.5,
                side: THREE.DoubleSide,
            });
            const exitPortalInner = new THREE.Mesh(
                exitPortalInnerGeometry,
                this.exitPortalInnerMaterial
            );
            exitPortalGroup.add(exitPortalInner);

            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            canvas.width = 512;
            canvas.height = 64;
            context.fillStyle = "#00ff00";
            context.font = "bold 32px Arial";
            context.textAlign = "center";
            context.fillText(
                "VIBEVERSE PORTAL",
                canvas.width / 2,
                canvas.height / 2
            );
            const texture = new THREE.CanvasTexture(canvas);
            const labelGeometry = new THREE.PlaneGeometry(30, 5);
            const labelMaterial = new THREE.MeshBasicMaterial({
                map: texture,
                transparent: true,
                side: THREE.DoubleSide,
            });
            const label = new THREE.Mesh(labelGeometry, labelMaterial);
            label.position.y = 20;
            exitPortalGroup.add(label);

            const exitPortalParticleCount = 500;
            const exitPortalParticles = new THREE.BufferGeometry();
            const exitPortalPositions = new Float32Array(
                exitPortalParticleCount * 3
            );
            const exitPortalColors = new Float32Array(exitPortalParticleCount * 3);

            for (let i = 0; i < exitPortalParticleCount * 3; i += 3) {
                const angle = Math.random() * Math.PI * 2;
                const radius = 15 + (Math.random() - 0.5) * 4;
                exitPortalPositions[i] = Math.cos(angle) * radius;
                exitPortalPositions[i + 1] = Math.sin(angle) * radius;
                exitPortalPositions[i + 2] = (Math.random() - 0.5) * 4;
                exitPortalColors[i] = 0;
                exitPortalColors[i + 1] = 0.8 + Math.random() * 0.2;
                exitPortalColors[i + 2] = 0;
            }

            exitPortalParticles.setAttribute(
                "position",
                new THREE.BufferAttribute(exitPortalPositions, 3)
            );
            exitPortalParticles.setAttribute(
                "color",
                new THREE.BufferAttribute(exitPortalColors, 3)
            );

            const exitPortalParticleMaterial = new THREE.PointsMaterial({
                size: 0.1,
                vertexColors: true,
                transparent: true,
                opacity: 0.6,
            });

            const exitPortalParticleSystem = new THREE.Points(
                exitPortalParticles,
                exitPortalParticleMaterial
            );
            exitPortalGroup.add(exitPortalParticleSystem);

            this.scene.add(exitPortalGroup);
            // this.exitPortalBox = new THREE.Box3().setFromObject(exitPortalGroup);
            this.exitPortalBox = exitPortalGroup;

            console.log(this.exitPortalBox, "group box");

            this.exitPortalParticles = exitPortalParticles; // Store for animation
            // </create exit portal>

            return true;
        } catch (error) {
            console.error('Error loading static character:', error);
            return false;
        }
    }

    createPauseModal() {
        // Create container for death message
        const container = document.createElement('div');
        container.style.position = 'fixed';
        container.style.top = '0';
        container.style.left = '0';
        container.style.width = '100%';
        container.style.height = '100%';
        container.style.backgroundColor = 'rgba(0,0,0,0.7)';
        container.style.color = 'white';
        container.style.flexDirection = 'column';
        container.style.justifyContent = 'center';
        container.style.alignItems = 'center';
        container.style.zIndex = '1000';
        container.style.display = 'none';

        // Create death message
        const message = document.createElement('h1');
        message.textContent = 'Game Paused';
        message.style.fontSize = '48px';
        message.style.marginBottom = '20px';
        message.style.color = '#ff3030';
        container.appendChild(message);

        // Create respawn countdown
        const messageBody = document.createElement('p');
        messageBody.innerHTML = "You've entered a portal! Redirecting...";
        messageBody.style.fontSize = '24px';
        messageBody.style.marginBottom = '40px';
        container.appendChild(messageBody);

        // Add to document
        document.body.appendChild(container);

        this.pauseModal = container;
    }

    pauseGame(url) {
        this.renderLoop.stop()

        this.redirectUrl = url;

        // Show the pause modal
        if (this.pauseModal) {
            this.pauseModal.style.display = "flex";
            console.log("Pause modal shown, redirect URL:", url);
        } else {
            console.error("Pause modal not found");
        }

        // Auto-redirect after 0.5 seconds if no action
        setTimeout(() => {
            if (!this.renderLoop.isActive() && this.redirectUrl) {
                console.log("Auto-redirecting to:", this.redirectUrl);
                window.location.href = this.redirectUrl;
            }
        }, 500);
    }


    update(player) {
        // Animate start portal
        if (this.startPortalParticles) {
            const startPositions =
                this.startPortalParticles.attributes.position.array;
            for (let i = 0; i < startPositions.length; i += 3) {
                startPositions[i + 1] += 0.05 * Math.sin(Date.now() * 0.001 + i);
            }
            this.startPortalParticles.attributes.position.needsUpdate = true;

            if (this.startPortalBox) {
                const playerBox = player.position.distanceTo(this.startPortalBox.position);

                if (playerBox < 4) {
                    console.log("Player near start portal");
                    const urlParams = new URLSearchParams(window.location.search);
                    const refUrl = urlParams.get("ref");
                    if (refUrl) {
                        let url =
                            refUrl.startsWith("http://") || refUrl.startsWith("https://")
                                ? refUrl
                                : "https://" + refUrl;
                        const currentParams = new URLSearchParams(window.location.search);
                        const newParams = new URLSearchParams();
                        for (const [key, value] of currentParams) {
                            if (key !== "ref") {
                                newParams.append(key, value);
                            }
                        }
                        const paramString = newParams.toString();
                        const finalUrl = url + (paramString ? "?" + paramString : "");
                        console.log("Pausing for Start Portal URL:", finalUrl);
                        this.pauseGame(finalUrl);
                    } else {
                        console.log("No ref URL provided for start portal");
                    }
                }
            }
        }

        // Animate exit portal
        if (this.exitPortalParticles) {
            const exitPositions =
                this.exitPortalParticles.attributes.position.array;
            for (let i = 0; i < exitPositions.length; i += 3) {
                exitPositions[i + 1] += 0.05 * Math.sin(Date.now() * 0.001 + i);
            }
            this.exitPortalParticles.attributes.position.needsUpdate = true;

            if (this.exitPortalBox) {
                const playerBox = player.position.distanceTo(this.exitPortalBox.position);

                if (playerBox < 4) {
                    console.log("Player near exit portal");
                    const currentParams = new URLSearchParams(window.location.search);
                    const newParams = new URLSearchParams();
                    newParams.append("portal", "true");
                    newParams.append(
                        "username",
                        this.player.name || "selfUsername"
                    );
                    newParams.append("color", "white");
                    newParams.append(
                        "speed",
                        this.player.movementSpeed || "currentSpeed"
                    );

                    for (const [key, value] of currentParams) {
                        newParams.append(key, value);
                    }
                    const paramString = newParams.toString();
                    const nextPage =
                        "https://portal.pieter.com" +
                        (paramString ? "?" + paramString : "");

                    console.log("Pausing for Exit Portal URL:", nextPage);
                    this.pauseGame(nextPage);
                }
            }
        }
    }
}